<!-- <div class="gs root-layout" [ngClass]="{'sidebar-opened': sidebarOpened}">
  <div class="custom-lay left-layout" [ngClass]="{'collapsed-sidebar': panelToggle}">
    <eyrus-side-panel>
      <eyrus-side-menu></eyrus-side-menu>
    </eyrus-side-panel>
  </div>
  <div class="lay right-layout">
    <router-outlet></router-outlet>
  </div>
</div> -->
<router-outlet></router-outlet>
